'use client';

import { AppProgressProvider } from '@bprogress/next';
import { SpeedInsights } from '@vercel/speed-insights/next';
import { Provider as JotaiProvider } from 'jotai';
import { ThemeProvider } from 'next-themes';

import { Toaster } from './ui/sonner';

export function Providers({ children }: { children: React.ReactNode }) {
  return (
    <JotaiProvider>
      <ThemeProvider
        enableSystem
        disableTransitionOnChange
        enableColorScheme
        storageKey="theme"
        defaultTheme="system"
        attribute="class"
      >
        <AppProgressProvider
          color="var(--foreground)"
          height="2px"
          delay={500}
          options={{ showSpinner: false }}
        >
          {children}
        </AppProgressProvider>

        <Toaster position="top-center" />
        {/* Performance-only (no visitor tracking); Vercel Analytics is
            consent-gated in ConsentManagerScripts. */}
        <SpeedInsights />
      </ThemeProvider>
    </JotaiProvider>
  );
}
